// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_BV-","col":"styles_col__2w_Ug"};